import { ReactComponent as CancelIcon } from "../../../images/cancel.svg";
import { ReactComponent as SubmitIcon } from "../../../images/submit.svg";
// import { ReactComponent as DeleteIcon } from "../../../images/delete.svg";

export default function ActionButtons({ localization, unitType, unitId, isDirty, onCancel, onSave, onDelete, language }) {
  return (
    <div className="action-buttons">
      <button
        id={`${unitType}-cancel-${unitId}`}
        className="action-button button"
        type="button"
        disabled={!isDirty}
        onClick={onCancel}
        aria-label={localization.cancelChanges[language]}
        title={isDirty ? localization.cancelChanges[language] : localization.unavailable[language]}
      >
        <CancelIcon className="action-button__icon" aria-hidden="true" />
      </button>
      <button
        id={`${unitType}-submit-${unitId}`}
        className="action-button button"
        type="button"
        disabled={!isDirty}
        onClick={onSave}
        aria-label={localization.saveChanges[language]}
        title={isDirty ? localization.saveChanges[language] : localization.unavailable[language]}
      >
        <SubmitIcon className="action-button__icon" aria-hidden="true" />
      </button>
      {/* <button
        id={`${unitType}-delete-${unitId}`}
        className="action-button button"
        type="button"
        onClick={onDelete}
        aria-label={`${localization.deleteButton[language]} ${unitType}`}
        title={`${localization.deleteButton[language]} ${unitType}`}
      >
        <DeleteIcon className="action-button__icon" />
      </button> */}
    </div>
  );
}
